import axios from "axios";

export const employeesService = {
  getEmployeesService: (params) =>
    axios.get("/employees", { auth: true, params: { ...params } }),
  deleteEmployeesService: (id) =>
    axios.delete(`/employees/${id}`, { auth: true }),
  addEmployeesService: (body) => axios.post("/employees", body, { auth: true }),
  editEmployeesService: (id, body) =>
    axios.patch(`/employees/${id}`, body, { auth: true }),
  changeStatusVEmployeesService: (id, body) =>
      axios.patch(`/employees/${id}/status`, body, {auth: true}),
};
